import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { Button, Glyphicon } from "react-bootstrap";

class Copy extends Component {
  render() {
    const { stores } = this.props;
    return (
      <Button bsStyle="success" {...this.props}>
        <Glyphicon glyph="copy" /> {stores.ui.translate.Copy}
      </Button>
    );
  }
}

export default inject("stores")(observer(Copy));



// WEBPACK FOOTER //
// ./src/Core/Components/Buttons/Copy.js